<button mat-button class="language-menu-toggle" [matMenuTriggerFor]="langMenu">
  <mat-icon>language</mat-icon>
  <div class="current-lang">{{ localeService.currentLang() }}</div>
</button>

<mat-menu #langMenu="matMenu" class="lang-switch-menu">
  @for (l of localeService.supported; track l) {
    <a
      mat-menu-item
      [routerLink]="langRelativeUrl() !== undefined ? [catalog.name + '/' + l.language + '/' + langRelativeUrl()] : null"
      routerLinkActive="active"
      [queryParams]="langSwitchQueryParams()"
      (click)="onLanguageClick($event, l.culture)"
      >{{ l.localName }}</a
    >
  }
</mat-menu>
